// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.booking-modal .sk-modal__title {\n  padding-top: 20px;\n}\n.sk-select--edit-btn:focus,\n.sk-select-btn:focus {\n  -webkit-box-shadow: var(--default-focus-shadow);\n          box-shadow: var(--default-focus-shadow);\n  outline: none;\n}\n", ""]);
// Exports
module.exports = exports;
